import { render, staticRenderFns } from "./content_dot.vue?vue&type=template&id=2c42254d&"
import script from "./content_dot.vue?vue&type=script&lang=js&"
export * from "./content_dot.vue?vue&type=script&lang=js&"
import style0 from "./content_dot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports